import React from 'react';

const Theft = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 20" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Theft_a"
        d="M447.5 385h-3.13v-2.5h1.88a.62.62 0 0 0 .58-.87l-2.77-6.63h-1.35l.52 1.25H440V380h4.8l.51 1.25h-1.56a.63.63 0 0 0-.63.63V385H440v10h8.75l-3.75-7.5zm-5.63-6.25a.63.63 0 1 1 0-1.25.63.63 0 0 1 0 1.25z"
      />
      <path
        id="Theft_b"
        d="M453.02 378.99h4v-1h-4a2.4 2.4 0 0 0-2.28 1.87l-.64 3.2a1.5 1.5 0 0 0-1.08 1.43v3.5a1 1 0 0 0 1 1v1.5c0 .82.68 1.5 1.5 1.5s1.5-.68 1.5-1.5v-1.5h4v-6h-5.9l.6-2.93a1.4 1.4 0 0 1 1.3-1.07m-1.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Theft_a" transform="translate(-440 -375)" />
    <use fill="currentColor" xlinkHref="#Theft_b" transform="translate(-440 -375)" />
  </svg>
);

export default Theft;



// WEBPACK FOOTER //
// ./src/common/icons/Theft.js